// ─────────────────────────────────────────────────────────────────────────
// SINGLE SWAP POINT for the object DETECTOR used by tracking + line-crossing
// (both play mode and code-mode Execute).
//
// Right now it wraps COCO-SSD (SSD-MobileNet, 80 classes, ships with the app,
// good for a few people at moderate range). To move to YOLO for long-range /
// CCTV multi-person detection, change ONLY this file:
//
//   1. Add a YOLO tfjs model under public/models (e.g. yolov8n_web_model/).
//   2. Load it here instead of coco-ssd and return the SAME shape from
//      detect(): [{ class, score, bbox: [x, y, w, h] }] in PIXELS.
//   3. Nothing else changes — objectTracker.js, trackingDetector.js and
//      AiExecute.jsx all consume this provider.
// ─────────────────────────────────────────────────────────────────────────
import { loadCocoSsd } from './detectors/objectDetector'
import { loadYolo, yoloDetect } from './yoloRuntime'

// ── SINGLE SWAP: 'yolo' (YOLOv8, better accuracy) or 'coco-ssd' (bundled,
// lightest). Change this one line to switch, or drop a different yolov8*_web_model
// folder in public/models and update MODEL_URL in yoloRuntime.js. YOLO falls
// back to coco-ssd automatically if its model fails to load. ──
export const DETECTOR_BACKEND = 'yolo'

let providerPromise = null

const cocoProvider = () =>
    loadCocoSsd().then((model) => ({
        backend: 'coco-ssd',
        detect: (video, max = 20) => model.detect(video, max),
    }))

// Returns a detector with an async detect(video, maxResults) -> pixel bboxes
// [{ class, score, bbox:[x,y,w,h] }], consumed by objectTracker / trackingDetector
// / AiExecute unchanged.
export function getDetector() {
    if (!providerPromise) {
        if (DETECTOR_BACKEND === 'yolo') {
            providerPromise = loadYolo()
                .then((model) => ({
                    backend: 'yolo',
                    detect: (video, max = 20) => yoloDetect(model, video, max),
                }))
                .catch((e) => {
                    console.warn(
                        '[detector] YOLO load failed, using coco-ssd',
                        e
                    )
                    return cocoProvider()
                })
        } else {
            providerPromise = cocoProvider()
        }
    }
    return providerPromise
}
